document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (toggle && menu) toggle.addEventListener('click', () => menu.classList.toggle('is-open'));
});

/* PagePilot cart drawer bridge */
document.addEventListener('click', (event) => {
  const cartLink = event.target.closest('a.novi-cart');
  if (!cartLink) return;

  const drawerButton = document.querySelector(
    'pagepilot-cart-drawer-trigger button'
  );

  if (drawerButton) {
    event.preventDefault();
    drawerButton.click();
  }
});


/* Novi cart badge: read Shopify's cart after asynchronous cart changes. */
(() => {
  if (window.__noviCartBadgeSync) return;
  window.__noviCartBadgeSync = true;

  const originalFetch = window.fetch;
  let timer;
  let revision = 0;

  function renderCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('a.novi-cart').forEach(link => {
      let badge = link.querySelector('[data-novi-cart-count]') || link.querySelector(':scope > span');
      if (count === 0) {
        if (badge) badge.remove();
      } else {
        if (!badge) {
          badge = document.createElement('span');
          link.appendChild(badge);
        }
        badge.setAttribute('data-novi-cart-count', '');
        badge.textContent = String(count);
      }
      link.setAttribute('aria-label', count === 0 ? 'Cart, empty' : 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function scheduleRefresh() {
    const requestRevision = ++revision;
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await originalFetch.call(window, root + 'cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (requestRevision === revision) renderCount(cart.item_count);
      } catch (_) {
        // Preserve the last known count on a transient network failure.
      }
    }, 80);
  }

  function isCartMutation(input) {
    try {
      const value = typeof input === 'string' || input instanceof URL ? input : input.url;
      const url = new URL(value, window.location.href);
      return url.origin === window.location.origin &&
        /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch (_) { return false; }
  }

  window.fetch = function(input, options) {
    const result = originalFetch.apply(this, arguments);
    if (isCartMutation(input)) {
      result.then(response => { if (response.ok) scheduleRefresh(); }, () => {});
    }
    return result;
  };

  // Third-party COD apps may use XMLHttpRequest instead of fetch.
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  const cartRequests = new WeakMap();
  XMLHttpRequest.prototype.open = function(method, url) {
    const result = originalOpen.apply(this, arguments);
    cartRequests.set(this, isCartMutation(url));
    return result;
  };
  XMLHttpRequest.prototype.send = function() {
    if (cartRequests.get(this)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) scheduleRefresh();
      }, { once: true });
    }
    return originalSend.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update'].forEach(name => {
    document.addEventListener(name, scheduleRefresh);
  });
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('a.novi-cart')) scheduleRefresh();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleRefresh();
  });
  window.addEventListener('pageshow', scheduleRefresh);
  window.addEventListener('focus', scheduleRefresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }
})();
